import React from "react";
import {
  DialogProps,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Body1,
  DialogActions,
  DialogTrigger,
  Button,
} from "@fluentui/react-components";

import { ClauseData } from "@/types/risk-analysis";

export interface DeletePlaybookRuleDialogProps extends Omit<DialogProps, "children"> {
  playbookRule: ClauseData;
  onAccept: () => void;
}

export function DeletePlaybookRuleDialog({ playbookRule, onAccept, ...props }: DeletePlaybookRuleDialogProps) {
  return (
    <Dialog {...props}>
      <DialogSurface
        aria-labelledby={`delete-${playbookRule.id}-title`}
        aria-describedby={`delete-${playbookRule.id}-content`}
      >
        <DialogBody>
          <DialogTitle id={`delete-${playbookRule.id}-title`}>Delete Playbook</DialogTitle>
          <DialogContent id={`delete-${playbookRule.id}-content`}>
            <Body1>
              Are you sure you want to delete the playbook rule “<b>{playbookRule.clauseTopic}</b>”?
            </Body1>
            <br />
            <Body1>This action cannot be undone.</Body1>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={onAccept}>
              Delete
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
